import {NeoModal} from "@/components/@modal/neo.modal";
import {useState} from "react";

export const NeoFieldImage: React.FC<any> = ({data, uid}) => {
  const [open, setOpen] = useState(false);
  const imagedriver = data[uid] ? data[uid] : "/images/avatar.png";

  return (
    <>
      <img
        className="h-10 w-10 cursor-zoom-in rounded-full border"
        src={imagedriver}
        alt="img"
        onClick={e => {
          e.stopPropagation();
          setOpen(true);
        }}
        onError={event => {
          event.currentTarget.src = "/images/avatar.png";
        }}
      />
      <NeoModal
        actionType={open ? "imagePreview" : null}
        onOpen={open}
        onClose={() => setOpen(false)}
        hasActions={false}
        data={{imageSrc: imagedriver}}
      />
    </>
  );
};
